import React from "react";
import "./ComingSoon.css";
const CommingSoon = () => {
  return (
    <div className="coming-soon-container">
      <img src="/Web Repair.gif" width={"300vw"} alt="coming soon" />
      <h2 style={{ color: "#615E83", marginTop: -20 }}>Coming Soon...</h2>
      <p style={{ textAlign: "center" }} className="m-0">
        We're excited to announce that our new website is under construction.
      </p>
      <p className="m-0" style={{ marginTop: -10, textAlign: "center" }}>
        Please check back soon for updates.
      </p>
    </div>
  );
};

export default CommingSoon;
